import React, { Component } from "react"
import breakpoints from "../components/break-points"
import constants from "../constants"
import Actions from "../actions"
import GridItem from "../components/px-grid-item"
import Store from "../store"
import { navigate } from "gatsby-link"
import { gsap } from "gsap"

class StoryPage extends Component {
  constructor(props) {
    super(props)
    this.section = React.createRef()
    this.infosSection = React.createRef()
    this.elements = []
    this.wrapper = undefined
    this.version = undefined
    this.observer = undefined
    this.pxContainer = undefined
    this.infos = undefined
    this.sprites = []
    this.oldTween = undefined
    this.scrollEl = undefined
    this.mq = undefined
    this.delta = 0
    this.scrollPos = 0
    this.state = {
      version: undefined,
      scale: 0
    }
  }
  componentDidMount() {
    this.onResize()
    this.scrollEl = document.getElementsByTagName("main")[0]
    window.addEventListener("resize", this.onResize)
    this.scrollEl.addEventListener("scroll", this.onScroll)
    Store.on(constants.PIXI_STAGE_READY, this.onPixiStageReady)
    if (window.Ticker) {
      window.Ticker.remove(this.onUpdate)
      window.Ticker.add(this.onUpdate)
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.version !== this.state.version && prevState.version !== undefined) window.location.reload()
    if (this.elements.length > 0) {
      if (!this.pxContainer) {
        this.setupPixi()
        this.setupIntersection()
      }
    }
    if (this.props.state === `close` && prevProps.state !== this.props.state) {
      gsap.to(this.infosSection.current, { autoAlpha: 0, duration: 0.6, ease: `expo.inout` })
    } else if (this.props.state === `open` && prevProps.state !== this.props.state) {
      gsap.to(this.infosSection.current, { autoAlpha: 1, duration: 0.6, ease: `expo.inout` })
    }
  }
  componentWillUnmount() {
    this.removeIntersection()
    this.removePixi()
    window.removeEventListener("resize", this.onResize)
    this.scrollEl.removeEventListener("scroll", this.onScroll)
    Store.off(constants.PIXI_STAGE_READY, this.onPixiStageReady)
    if (window.Ticker) window.Ticker.remove(this.onUpdate)
  }
  setupPixi = () => {
    const PIXI = require('pixi.js')
    this.pxContainer = new PIXI.Container()
    this.pxContainer.sortableChildren = true
    this.elements.forEach(item => {
      const sprite = new GridItem(item, this.pxContainer)
      this.sprites.push(sprite)
    })
    this.onResize()
    const infoElements = [...this.infosSection.current.getElementsByClassName(`info-element`)]
    this.infos = infoElements.map(item => {
      const title = item.getElementsByClassName(`title`)[0]
      const description = item.getElementsByClassName(`description`)[0]
      return {
        tween: gsap.fromTo([title, description], { y: 20, autoAlpha: 0}, { y: 0, autoAlpha: 1, duration: 0.6, ease: `expo.out`, stagger: 0.1 }).pause(0)
      }
    })
    setTimeout(Actions.addChild, 0, this.pxContainer)
  }
  removePixi = () => {
    if (!this.pxContainer) return
    this.sprites.forEach(item => item.remove())
    this.pxContainer.destroy({ children: true })
    this.sprites = []
    setTimeout(Actions.removeChild, 0, this.pxContainer)
  }
  setupIntersection = () => {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const target = entry.target
        if (entry.isIntersecting) {
          const id = target.getAttribute(`data-id`)
          const ii = parseInt(target.getAttribute(`data-ii`))
          this.trackII = ii
          const current = this.sprites.filter(item => item.id === id)[0]
          // Check so to remove the previous visible zone title
          if (!isNaN(ii)) {
            if (this.oldTween) this.oldTween.pause(0)
            this.oldTween = this.infos[ii]?.tween.timeScale(1).play(0)
          }
          if (current) current.loadImage(this.mq)
          if (id === `end-page`) {
            if (Store.story === constants.COLOUR) navigate(`/${this.props.lang}/story/${constants.SCIENCE.toLowerCase()}`)
            else navigate(`/${this.props.lang}/story/${constants.COLOUR.toLowerCase()}`)
          }
        } else {
          const ii = parseInt(target.getAttribute(`data-ii`))
          this.infos[ii]?.tween.timeScale(10).reverse()
        }
      })
    })
    const assets = [...this.section.current.getElementsByClassName(`asset-element`)]
    assets.forEach(item => this.observer.observe(item))
  }
  removeIntersection = () => {
    if (this.observer) this.observer.disconnect()
  }
  onResize = () => {
    const w = window.innerWidth
    const version = window.innerWidth < constants.breakpoints.lg ? constants.MOBILE : constants.DESKTOP
    this.elements = this.props.data[version].elements
    this.wrapper = this.props.data[version].wrapper
    const newScale = (w / this.wrapper.width) * 1
    this.mq = constants.breakpoints[breakpoints(w).id]
    if (newScale !== this.state.scale) {
      this.setState({ scale: newScale, version: version })
    }
    if (this.sprites.length > 0) {
      this.sprites.forEach(item => {
        item.setPos(item.initial.x * newScale, item.initial.y * newScale)
        item.size(item.initial.width * newScale, item.initial.height * newScale)
      })
    }
  }
  onUpdate = () => {
    if (this.pxContainer) this.pxContainer.y += (-this.scrollPos - this.pxContainer.y) * 0.15
  }
  onPixiStageReady = () => {
    // Only in first time, after it will be available in window.Ticker
    window.Ticker.add(this.onUpdate)
  }
  onScroll = () => {
    this.scrollPos = this.scrollEl.scrollTop
  }
  onWheel = (e) => {
    this.delta = e.deltaY
  }
  render() {
    const wrapperWidth = this.wrapper?.width * this.state.scale
    const wrapperHeight = this.wrapper?.height * this.state.scale + 100
    return (
      <div>
        <div ref={this.infosSection}>
        {
          this.props.locals.scroll.map((item, index) => {
            return (
              <div
                key={`scroll-element-${index}-${this.props.id}`}
                className={`fixed bottom-24 left-0 px-6 lg:px-0 lg:bottom-8 lg:left-8 max-w-2xl info-element`}
              >
                <div className={`font-sans text-2xl lg:text-7xl pl-6 title opacity-0`}>{item.title}</div>
                { item.description && <div className={`bg-white rounded-4xl inline-block px-6 py-5 font-sans text-sm lg:text-lg mt-3 description opacity-0`}>{item.description}</div>}
              </div>
            )
          })
        }
        </div>
        <div ref={this.section} onWheel={this.onWheel} style={{ width: `${wrapperWidth}px`, height: `${wrapperHeight}px` }} className={`relative top-0 left-0`}>
          {
            this.elements.map((item, index) => {
              return (
                <div
                  key={`element-${index}-${this.props.id}-${item.id}`}
                  style={{ left: `${item.x * this.state.scale}px`, top: `${item.y * this.state.scale}px`, width: `${item.width * this.state.scale}px`, height: `${item.height * this.state.scale}px` }}
                  className={`absolute asset-element`}
                  data-id={item.id}
                />
              )
            })
          }
          { this.state.version &&
            this.props.locals.scroll.map((item, index) => {
              const zone = this.props.scrollingPositions[index][this.state.version]
              return (
                <div
                  key={`inter-scroll-element-${index}-${this.props.id}`}
                  style={{ left: `${0}px`, top: `${zone.start * this.state.scale}px`, width: `${50}px`, height: `${(zone.end-zone.start) * this.state.scale}px` }}
                  className={`absolute asset-element`}
                  data-ii={index}
                />
              )
            })
          }
          { this.elements.length > 0 && <div data-id={`end-page`} style={{ left: `0px`, top: `${wrapperHeight-80}px`, width: `100px`, height: `50px` }} className={`asset-element absolute`}></div>}
        </div>
      </div>
    )
  }
}

export default StoryPage
